package com.vamvisions.main.portfolio.presentation.portfolio

import com.vamvisions.main.core.presentation.i18n.UiText
import com.vamvisions.main.portfolio.presentation.common.LinkTarget
import com.vamvisions.main.portfolio.presentation.common.SkillUi

/**
 * The entries of each page section, in server order. While the language changes, the previous content stays with
 * [isLoading] true.
 */
data class PortfolioState(
    val isLoading: Boolean = true,
    val timeline: List<ExperienceUi> = emptyList(),
    val learning: List<ExperienceUi> = emptyList(),
    val education: List<ExperienceUi> = emptyList(),
    val error: UiText? = null,
) {
    val hasContent: Boolean get() = timeline.isNotEmpty() || learning.isNotEmpty() || education.isNotEmpty()
}

/**
 * One entry card. [highlights] are lines: one is a paragraph, several are bullet points. [link] is null when the
 * entry links nowhere. [isCurrent] marks the ongoing first timeline entry, which stands out and links to the Projects
 * and Contact pages.
 */
data class ExperienceUi(
    val slug: String,
    val name: String,
    val role: String,
    val period: String,
    val highlights: List<String>,
    val link: LinkTarget?,
    val skills: List<SkillUi>,
    val isCurrent: Boolean = false,
)
